module.exports = __webpack_public_path__ + "bb0750c63d30d259e82a4701e3cc744c.svg";